/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {IconIsActive} from '../../../../../components/IconIsActive'

type Props = {
  value: any
  activeAlert?: boolean
  alertObservation?: string
  showAlertIcons?: boolean
}

const CustonCell: FC<Props> = ({value, activeAlert, alertObservation, showAlertIcons = false}) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-flex flex-column'>
        {showAlertIcons ? (
          <span role='button' className=' text-hover-danger'>
            {activeAlert && <IconIsActive text={alertObservation} />}
            {value}
          </span>
        ) : (
          value
        )}
      </div>
    </div>
  )
}

export {CustonCell}
